<table class="cng-table full planning">
  <caption>
    <h3 class="title">{{ 'agent:general_information.globalInfoTable_title' | translate }}</h3>
  </caption>
  <thead>
    <tr class="timeLabel">
      <td style="text-align: right; padding-right: 1.5em">{{ 'commons:basic.hours.long' | translate }}</td>
      <td
        colspan="4"
        *ngFor="
          let myHour of [
            '00',
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20',
            '21',
            '22',
            '23'
          ]
        "
      >
        <span
          >{{ myHour }} <span class="nodisplay">{{ 'commons:basic.hour' | translate }}</span></span
        >
      </td>
      <td class="capitalize" *ngIf="hasActivationRight$ | async">
        {{ 'commons:basic.active' | translate }}
      </td>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let planning of plannings$ | async; let $index = index" [ngSwitch]="planning.key">
      <ng-container
        *ngSwitchCase="'channel'"
        [ngTemplateOutlet]="channelRef"
        [ngTemplateOutletContext]="{
          channel: planning.value,
          index: $index
        }"
      ></ng-container>
      <ng-container
        *ngSwitchCase="'skill'"
        [ngTemplateOutlet]="skillRef"
        [ngTemplateOutletContext]="{
          channel: planning.value.channel,
          skillId: planning.value.skillId,
          index: $index
        }"
      ></ng-container>
    </ng-container>
  </tbody>
</table>

<ng-template #channelRef let-channel="channel" let-index="index">
  <tr class="head" cng-agent-planning-row-channel [channel]="channel" [index]="index"></tr>
</ng-template>

<ng-template #skillRef let-channel="channel" let-skillId="skillId" let-index="index">
  <tr cng-agent-planning-row-skill [channel]="channel" [skillId]="skillId" [index]="index"></tr>
</ng-template>
